import { render, staticRenderFns } from "./capture.vue?vue&type=template&id=319b25b6&scoped=true"
import script from "./capture.vue?vue&type=script&lang=js"
export * from "./capture.vue?vue&type=script&lang=js"
import style0 from "./capture.vue?vue&type=style&index=0&id=319b25b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b25b6",
  null
  
)

export default component.exports